var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"outlined":"","dense":"","hide-details":"auto","items":_vm.time_slots,"label":_vm.label,"rules":_vm.requiredRules,"auto-select-first":"","clearable":"","filter":_vm.search,"disabled":_vm.disabled},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }